import React from 'react';
import { formatTime } from '../../../Feedback/components/Helpers';
import SubmitIcon from '../../../../assets/images/submit-icon.svg';
import SidebarQuestion from './SidebarQuestion';
import Button from '../../../commonComponent/Button';
const Question = ({
    questionInfo,
    isSpeaking,
    answerTime,
    handleEndCall,
    candidatePeer,
    isButtonDisabled,
    handleNextQuestionClick,
    isNextButtonEnabled,
    question,
    position,
    setPosition,
    isQuestionRunning,
}) => {
    const submitAnswerButtonEnabled = !isSpeaking && !isButtonDisabled && isNextButtonEnabled;
    const renderText = (label, imgSrc) => (
        <>
            <span>{label}</span>
            {imgSrc && <img className="btn-icon" src={imgSrc} alt="" />}
        </>
    );

    return (
        <div className="sidebar-container-coding">
            <div className="question-timer-container-coding d-flex justify-content-between">
                <div className="d-flex align-items-center">
                    {isQuestionRunning ? (
                        <Button
                            text={renderText('Submit Answer', SubmitIcon)}
                            className={`common-btn timer-btn${!submitAnswerButtonEnabled ? ' disabled' : ''}`}
                            onClick={handleNextQuestionClick}
                            disabled={!submitAnswerButtonEnabled}
                        />
                    ) : (
                        <Button
                            text={renderText('Submit', SubmitIcon)}
                            className="common-btn timer-btn"
                            onClick={() => handleEndCall()}
                        />
                    )}
                    <div className="next-ques-time-countdown">{formatTime(answerTime) ?? '00:00'}</div>
                </div>
            </div>
            <SidebarQuestion
                question={question}
                questionType={questionInfo?.questionType}
                candidatePeer={candidatePeer}
                position={position}
                setPosition={setPosition}
            />
        </div>
    );
};

export default Question;
